import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Context } from '../Context/Context'
import close from '../Components/Images/x-close.png';
import Orange from '../Components/Images/orange.png'
import Red from '../Components/Images/red.png'
import Green from '../Components/Images/green.png'
import ComingSoon from './ComingSoon';
import SelectAcctModal from './SelectAcctModal';
import refresh from '../Components/Images/refresh.svg'

const ViewInvoiceBar = () => {

    const { handleViewInvoice, viewInvoice, fetchInvoices, handleDeleteInvoice, selectedInvoice } = useContext(Context)
    const token = localStorage.getItem('token');
    const invoiceID = localStorage.getItem('invoiceID')

    const [openSelectAcct, setOpenSelectAcct] = useState(false)


    // const handleClick = () => {
    //     setSelectedInvoice(prev => ({
    //         ...prev,
    //         status: 'paid'
    //     }))
    // }
    const [comingSoon, setComingSoon] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [invoiceDetails, setInvoiceDetails] = useState([])


    const handleDelete = (id) => {
        localStorage.setItem('invoiceID', id);
    };

    const fetchInvoice = useCallback(async () => {
        try {
            setIsLoading(true);

            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/invoices/${invoiceID}`, {
                method: "GET",
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            const data = await res.json();
            setInvoiceDetails(data);
        } catch (error) {
            console.error("Failed to fetch invoice detail", error);
        } finally {
            setIsLoading(false);
        }
    }, [invoiceID, token]);

    const updateStatus = async () => {
        try {
            setIsLoading(true);

            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/invoices/${invoiceID}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
                body: JSON.stringify({ status: "paid" })
            });
            const data = await res.json();

            fetchInvoices()
            fetchInvoice();
            return data;
            // setInvoiceDetails(data);
        } catch (error) {
            console.error("Failed to fetch invoice detail", error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (!viewInvoice) return

        fetchInvoice();
    }, [viewInvoice, fetchInvoice]);

    return (
        <div className={`fixed top-0 h-screen bg-white lg:p-10 py-8 px-3 duration-700 text-black z-30 overflow-auto ${viewInvoice ? 'sm:w-[510px] w-full right-0' : 'right-[-100%] w-[40%]'}`}>
            {isLoading ? (
                <div className="flex items-center justify-center h-full">
                    <p className="text-lg font-medium text-[#531CB3]">Loading invoice details...</p>
                </div>
            ) : (
                <>
                    <div className='flex gap-2 justify-between'>
                        <div>
                            <div className='flex items-center gap-2'>
                                <p className='text-[20px] font-medium text-[#1D1C1F]'>{invoiceDetails.payer_name}</p>
                                <img
                                    src={refresh}
                                    alt=""
                                    onClick={fetchInvoice}
                                    className='cursor-pointer'
                                />
                            </div>
                            {invoiceDetails && (
                                invoiceDetails.status === 'paid' ? (
                                    <p className='text-[#525154]'>Invoice has been sent to payer.</p>
                                ) : (
                                    <p className='text-[#525154]'>Invoice has not been sent to payer yet.</p>
                                )
                            )}
                        </div>
                        <img
                            className='size-5 mt-1 cursor-pointer' src={close} alt=""
                            onClick={handleViewInvoice}
                        />
                    </div>
                    <div className='flex gap-[6px] mt-5 sp:text-[14px] text-[12.8px] font-medium'>
                        <button
                            onClick={() => {
                                handleDeleteInvoice()
                                handleDelete(invoiceDetails.id)
                            }}
                            className='p-2 px-4 border-[1.2px] border-[#FCA5A5] text-[#EF4444] rounded-lg'
                        >
                            Delete
                        </button>
                        <button
                            disabled={isLoading}
                            onClick={() => {
                                setOpenSelectAcct(true)
                            }}
                            className={`p-2 px-4 border rounded-lg ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                            {isLoading ? 'Preparing...' : 'Download'}
                        </button>
                        {invoiceDetails && (
                            <button
                                onClick={() => setComingSoon(!comingSoon)}
                                className={`p-2 px-4 bg-[#531CB3] text-white border rounded-lg`}
                            >
                                Send invoice
                            </button>
                        )}
                    </div>
                    <div className='mt-10 flex justify-between border-[1.2px] rounded-lg border-[#F3F0F7] p-5'>
                        <div className='flex flex-col gap-2'>
                            <p className='text-[#525154] tetx-[14px]'>Status</p>
                            {invoiceDetails && (
                                <p className={`flex items-center gap-1 ${invoiceDetails.status === 'pending' ? 'text-[#F59E0B]' : invoiceDetails.status === 'paid' ? 'text-[#1CB353]' : 'text-[#EF4444]'}`}>
                                    <img src={invoiceDetails.status === 'pending' ? Orange : invoiceDetails.status === 'paid' ? Green : Red} alt="" />
                                    {` ${invoiceDetails.status}`}
                                </p>
                            )}
                        </div>
                        <div className='flex flex-col gap-2'>
                            <p className='text-[#525154] tetx-[14px]'>Date created</p>
                            <p className='text-[16px] text-[#1D1C1F]'>
                                {new Date(invoiceDetails.date_created).toLocaleDateString("en-GB", {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                })}
                            </p>
                        </div>
                        <div className='flex flex-col gap-2'>
                            <p className='text-[#525154] tetx-[14px]'>Date due</p>
                            <p className='text-[16px] text-[#1D1C1F]'>
                                {new Date(invoiceDetails.due_date).toLocaleDateString("en-GB", {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                })}
                            </p>
                        </div>
                    </div>
                    <div className='mt-10'>
                        <div className='flex justify-between'>
                            <p className='text-[18px] text-[#1D1C1F]'>Payer</p>
                            {/* <p className='text-[14px] text-[#531CB3] cursor-pointer'>View payer</p> */}
                        </div>
                        <div className='mt-5'>
                            <h1 className='text-[16px] font-medium text-[#302F33]'>{invoiceDetails.payer_name}</h1>
                            <p className='text-[#525154] text-[14px]'><span className='text-[#531CB3]'>{invoiceDetails.payer_email}</span></p>
                        </div>
                    </div>
                    <div className='mt-7'>
                        <p className='text-[18px] text-[#1D1C1F] font-medium'>Invoice summary</p>

                        {invoiceDetails?.breakdown?.map((item, index) => (
                            <div key={index}>
                                <div className='flex justify-between my-5'>
                                    <p className='text-[#302F33] text-[16px]'>{item.item_name}</p>
                                    <p className='text-[#302F33] text-[16px]'>
                                        ${(item.unit_price * item.quantity).toFixed(2)}
                                    </p>
                                </div>

                                {item.unit_price && item.quantity && (
                                    <div className='mt-2 flex flex-col gap-2'>
                                        <p className='text-[14px] text-[#78757A]'>Unit price: ${item.unit_price}</p>
                                        <p className='text-[14px] text-[#78757A]'>Quantity: {item.quantity}</p>
                                    </div>
                                )}
                            </div>
                        ))}


                        <div className='text-[16px] text-[#1D1C1F] flex justify-between border border-[#F3F0F7] rounded-lg p-4 mt-5'>
                            <p>Total</p>
                            <p className='font-semibold'>
                                ${invoiceDetails?.breakdown?.reduce((total, item) => {
                                    const itemAmount = item.unit_price && item.quantity
                                        ? item.unit_price * item.quantity
                                        : 0
                                    return total + itemAmount;
                                }, 0).toFixed(2)}
                            </p>
                        </div>

                    </div>
                    <div className='mt-7 flex flex-col gap-3'>
                        <p className='text-[18px] text-[#1D1C1F] font-medium'>Invoice note</p>
                        <p className='text-[#525154] text-[16px] font-normal'>{invoiceDetails.notes}</p>
                    </div>
                    {selectedInvoice && (
                        <button
                            onClick={updateStatus}
                            className={`bg-[#1CB353] text-white py-[10px] px-4 w-full rounded-lg mt-9 ${selectedInvoice.status === 'paid' && 'hidden'}`}
                        >
                            Mark as paid
                        </button>
                    )}
                </>
            )
            }
            <ComingSoon setComingSoon={setComingSoon} comingSoon={comingSoon} />
            <SelectAcctModal setOpenSelectAcct={setOpenSelectAcct} openSelectAcct={openSelectAcct} invoiceDetails={invoiceDetails} />
        </div >
    )
}

export default ViewInvoiceBar